// Soft UI Dashboard PRO React helper functions
import pxToRem from "./../../functions/pxToRem";

export default {
    styleOverrides: {
        "&.MuiStepContent-root": {
            padding: "100px",
            background: "red"
        }
    }
};
